import { styled } from "@mui/material";

export const ToolbarWrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.toolbar,
  marginBottom: theme.spacing(0.5),
  overflowX: "hidden",
}));
